import { useEffect, useState } from 'react';
import { fetchAllUsers, registerUser, toggleUserActive, deleteUser } from '../../services/api';
// import AdminLayout from '../../components/AdminLayout'; // TODO: Create AdminLayout or use a generic wrapper
import { useNavigate } from 'react-router-dom';
// import { FaUserMd, FaUserPlus } from 'react-icons/fa'; // react-icons is in top level package.json but not explicitly in v2 package.json, might work if hoisted or if I install it. 
// Step 115 shows react-icons is NOT in v2 package.json. I will avoid icons for now or use text.

function ConfirmDialog({ open, onClose, onConfirm, user }) {
    if (!open) return null;
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.25)', zIndex: 1000,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 16px #8884', padding: 32, minWidth: 320, maxWidth: '90vw', textAlign: 'center' }}>
                <h3 style={{ color: '#d32f2f', marginBottom: 16 }}>Confirmer la suppression</h3>
                <div style={{ marginBottom: 24 }}>Voulez-vous vraiment supprimer l'utilisateur <b>{user?.email}</b> ?<br />Cette action est <b>irréversible</b>.</div>
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
                    <button onClick={onClose} style={{ background: '#eee', color: '#222', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer' }}>Annuler</button>
                    <button onClick={onConfirm} style={{ background: '#d32f2f', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer' }}>Supprimer</button>
                </div>
            </div>
        </div>
    );
}

function AddUserDialog({ open, onClose, onAdd }) {
    const [step, setStep] = useState('choose'); // choose | form
    const [role, setRole] = useState('');
    const [form, setForm] = useState({ email: '', password: '', phone: '', address: '', postalCode: '', sex: '', age: '', specialty: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    function reset() {
        setStep('choose'); setRole(''); setForm({ email: '', password: '', phone: '', address: '', postalCode: '', sex: '', age: '', specialty: '' }); setError('');
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true); setError('');
        try {
            const payload = {
                email: form.email,
                password: form.password,
                role: role,
                phone: form.phone,
                address: form.address,
                postalCode: form.postalCode,
                gender: form.sex, // db uses gender, UI uses sex
                age: form.age,
                specialty: form.specialty
            };
            await registerUser(payload);
            onAdd();
            reset();
            onClose();
        } catch (err) {
            setError(err.response?.data?.error || 'Erreur lors de la création');
        } finally {
            setLoading(false);
        }
    }

    if (!open) return null;
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.25)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 16px #8884', padding: 32, minWidth: 340, maxWidth: '95vw', textAlign: 'center' }}>
                {step === 'choose' && (
                    <>
                        <h3 style={{ color: '#1976d2', marginBottom: 24 }}>Ajouter un utilisateur</h3>
                        <div style={{ display: 'flex', gap: 32, justifyContent: 'center', marginBottom: 24 }}>
                            <button onClick={() => { setRole('patient'); setStep('form'); }} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 8, padding: '18px 32px', fontWeight: 700, fontSize: 18, display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                                Patient
                            </button>
                            <button onClick={() => { setRole('doctor'); setStep('form'); }} style={{ background: '#388e3c', color: '#fff', border: 'none', borderRadius: 8, padding: '18px 32px', fontWeight: 700, fontSize: 18, display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                                Médecin
                            </button>
                        </div>
                        <button onClick={onClose} style={{ background: '#eee', color: '#222', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer' }}>Annuler</button>
                    </>
                )}
                {step === 'form' && (
                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'stretch', marginTop: 8 }}>
                        <h3 style={{ color: role === 'doctor' ? '#388e3c' : '#1976d2', marginBottom: 0 }}>Nouveau {role === 'doctor' ? 'médecin' : 'patient'}</h3>
                        <input type="email" placeholder="Email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                        <input type="password" placeholder="Mot de passe" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                        <input type="tel" placeholder="Téléphone" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                        <input type="text" placeholder="Adresse" value={form.address} onChange={e => setForm(f => ({ ...f, address: e.target.value }))} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                        <input type="text" placeholder="Code postal" value={form.postalCode} onChange={e => setForm(f => ({ ...f, postalCode: e.target.value }))} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                        <select value={form.sex} onChange={e => setForm(f => ({ ...f, sex: e.target.value }))} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }}>
                            <option value="">Sexe</option>
                            <option value="male">Homme</option>
                            <option value="female">Femme</option>
                            <option value="other">Autre</option>
                        </select>
                        <input type="number" placeholder="Âge" value={form.age} onChange={e => setForm(f => ({ ...f, age: e.target.value }))} min={0} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                        {role === 'doctor' && (
                            <input type="text" placeholder="Spécialité" value={form.specialty} onChange={e => setForm(f => ({ ...f, specialty: e.target.value }))} required style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                        )}
                        {error && <div style={{ color: '#d32f2f', fontWeight: 600 }}>{error}</div>}
                        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 8 }}>
                            <button type="button" onClick={reset} style={{ background: '#eee', color: '#222', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer' }}>Retour</button>
                            <button type="submit" disabled={loading} style={{ background: role === 'doctor' ? '#388e3c' : '#1976d2', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>{loading ? 'Ajout...' : 'Confirmer'}</button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

export default function UserList() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [updating, setUpdating] = useState(null); // id en cours de maj
    const [deleting, setDeleting] = useState(null); // id en cours de suppression
    const [confirmUser, setConfirmUser] = useState(null); // user à supprimer
    const [addOpen, setAddOpen] = useState(false);
    // Filtres pour chaque colonne
    const [filters, setFilters] = useState({
        id: '',
        email: '',
        role: '',
        is_active: '',
        created_at: ''
    });

    useEffect(() => {
        async function load() {
            try {
                const data = await fetchAllUsers();
                setUsers(data);
            } catch (error) {
                console.error('Erreur lors du chargement des utilisateurs:', error);
                setError('Erreur lors du chargement des utilisateurs');
            } finally {
                setLoading(false);
            }
        }
        load();
    }, []);

    // Changement d'état actif/inactif
    async function handleToggleActive(user) {
        setUpdating(user.id);
        try {
            await toggleUserActive(user.id, !user.is_active);
            setUsers(users => users.map(u => u.id === user.id ? { ...u, is_active: !u.is_active } : u));
        } catch (error) {
            console.error('Erreur lors de la mise à jour de l\'utilisateur:', error);
            alert("Erreur lors de la mise à jour de l'utilisateur");
        } finally {
            setUpdating(null);
        }
    }

    // Suppression utilisateur avec confirmation
    async function handleDeleteUser(user) {
        setConfirmUser(user);
    }

    async function confirmDelete() {
        if (!confirmUser) return;
        setDeleting(confirmUser.id);
        try {
            await deleteUser(confirmUser.id);
            setUsers(users => users.filter(u => u.id !== confirmUser.id));
            setConfirmUser(null);
        } catch (error) {
            console.error('Erreur lors de la suppression de l\'utilisateur:', error);
            alert("Erreur lors de la suppression de l'utilisateur");
        } finally {
            setDeleting(null);
        }
    }

    async function refreshUsers() {
        setLoading(true);
        try {
            const data = await fetchAllUsers();
            setUsers(data);
        } catch (error) {
            console.error('Erreur lors du rafraîchissement:', error);
            setError('Erreur lors du rafraîchissement');
        } finally {
            setLoading(false);
        }
    }

    const filteredUsers = users.filter(u =>
        (filters.id === '' || String(u.id).includes(filters.id)) &&
        (filters.email === '' || u.email.toLowerCase().includes(filters.email.toLowerCase())) &&
        (filters.role === '' || u.role === filters.role) &&
        (filters.is_active === '' || (filters.is_active === 'oui' ? u.is_active : !u.is_active)) &&
        (filters.created_at === '' || (u.created_at && new Date(u.created_at).toLocaleString().includes(filters.created_at)))
    );

    return (
        <div style={{ padding: 32 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
                <h2 style={{ color: '#1976d2' }}>Liste des utilisateurs</h2>
                <button onClick={() => setAddOpen(true)} style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, padding: '10px 24px', fontWeight: 700, fontSize: 16, display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
                    + Ajouter
                </button>
            </div>
            <button onClick={() => navigate('/admin')} style={{ marginBottom: 24, background: '#1976d2', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', fontWeight: 600, cursor: 'pointer' }}>
                ← Retour au Dashboard
            </button>
            {loading ? (
                <div>Chargement...</div>
            ) : error ? (
                <div style={{ color: 'red' }}>{error}</div>
            ) : (
                <div style={{ overflowX: 'auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px #e0e0e0', padding: 24 }}>
                    <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: 16 }}>
                        <thead>
                            <tr style={{ background: '#f5f6fa' }}>
                                <th style={{ padding: '12px 8px', width: 60, maxWidth: 80, textAlign: 'left', fontWeight: 700, color: '#1976d2', borderBottom: '2px solid #e0e0e0' }}>ID<br />
                                    <input style={{ width: '90%', fontSize: 14 }} value={filters.id} onChange={e => setFilters(f => ({ ...f, id: e.target.value }))} placeholder="Filtrer..." />
                                </th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700, color: '#1976d2', borderBottom: '2px solid #e0e0e0' }}>Email<br />
                                    <input style={{ width: '90%', fontSize: 14 }} value={filters.email} onChange={e => setFilters(f => ({ ...f, email: e.target.value }))} placeholder="Filtrer..." />
                                </th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700, color: '#1976d2', borderBottom: '2px solid #e0e0e0' }}>Rôle<br />
                                    <select style={{ width: '90%', fontSize: 14 }} value={filters.role} onChange={e => setFilters(f => ({ ...f, role: e.target.value }))}>
                                        <option value="">Tous</option>
                                        <option value="admin">Admin</option>
                                        <option value="doctor">Médecin</option>
                                        <option value="patient">Patient</option>
                                    </select>
                                </th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700, color: '#1976d2', borderBottom: '2px solid #e0e0e0' }}>Actif<br />
                                    <select style={{ width: '90%', fontSize: 14 }} value={filters.is_active} onChange={e => setFilters(f => ({ ...f, is_active: e.target.value }))}>
                                        <option value="">Tous</option>
                                        <option value="oui">Oui</option>
                                        <option value="non">Non</option>
                                    </select>
                                </th>
                                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700, color: '#1976d2', borderBottom: '2px solid #e0e0e0' }}>Créé le<br />
                                    <input style={{ width: '90%', fontSize: 14 }} value={filters.created_at} onChange={e => setFilters(f => ({ ...f, created_at: e.target.value }))} placeholder="Filtrer..." />
                                </th>
                                <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 700, color: '#d32f2f', borderBottom: '2px solid #e0e0e0', width: 80 }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers.map(u => (
                                <tr key={u.id} style={{ borderBottom: '1px solid #f0f0f0', transition: 'background 0.2s', background: u.is_active ? '#fff' : '#f3f3f3', color: u.is_active ? undefined : '#aaa' }}>
                                    <td style={{ padding: '10px 8px', color: '#333', width: 60, maxWidth: 80, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.id}</td>
                                    <td style={{ padding: '10px 16px', color: '#333' }}>{u.email}</td>
                                    <td style={{ padding: '10px 16px', color: u.role === 'admin' ? '#d32f2f' : u.role === 'doctor' ? '#388e3c' : '#1976d2', fontWeight: 600 }}>{u.role}</td>
                                    <td style={{ padding: '10px 16px' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: u.role === 'admin' ? 'not-allowed' : 'pointer', opacity: u.role === 'admin' ? 0.5 : 1 }}>
                                            <input type="checkbox" checked={u.is_active} disabled={updating === u.id || u.role === 'admin'} onChange={() => handleToggleActive(u)} style={{ accentColor: '#1976d2', width: 20, height: 20 }} />
                                            <span style={{
                                                display: 'inline-block',
                                                width: 12,
                                                height: 12,
                                                borderRadius: '50%',
                                                background: u.is_active ? '#4caf50' : '#e53935',
                                                marginRight: 8,
                                                verticalAlign: 'middle'
                                            }}></span>
                                            {u.is_active ? 'Oui' : 'Non'}
                                        </label>
                                    </td>
                                    <td style={{ padding: '10px 16px', color: '#888' }}>{u.created_at ? new Date(u.created_at).toLocaleString() : ''}</td>
                                    <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                                        <button onClick={() => handleDeleteUser(u)} disabled={deleting === u.id || u.role === 'admin'} style={{ background: '#fff', color: '#d32f2f', border: '1px solid #d32f2f', borderRadius: 4, padding: '4px 12px', fontWeight: 600, cursor: u.role === 'admin' ? 'not-allowed' : 'pointer', opacity: deleting === u.id || u.role === 'admin' ? 0.5 : 1 }}>
                                            {deleting === u.id ? 'Suppression...' : 'Supprimer'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <ConfirmDialog open={!!confirmUser} onClose={() => setConfirmUser(null)} onConfirm={confirmDelete} user={confirmUser} />
            <AddUserDialog open={addOpen} onClose={() => setAddOpen(false)} onAdd={refreshUsers} />
        </div>
    );
}
